import React, { useState, useEffect } from "react";
import { Modal, Fade, Box, Typography, Grid, Button } from "@mui/material";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
const MapModal = ({ open, onClose, handleConfirm }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [address, setAddress] = useState("");
  const [center, setCenter] = useState(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          return { lat: latitude, lng: longitude };
        },
        (error) => {
          console.error(
            "Error fetching location during initialization:",
            error,
          );
          return null;
        },
      );
    }
    return null;
  });
  const [loadingLocation, setLoadingLocation] = useState(true);

  const libraries = ["places"];
  const api_key = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: api_key,
    libraries,
  });

  const mapContainerStyle = {
    width: "100%",
    height: "100%",
  };

  const geocodeAddress = async (location) => {
    try {
      const geocoder = new window.google.maps.Geocoder();
      const results = await geocoder.geocode({ location });
      if (results.results[0]) {
        setAddress(results.results[0].formatted_address);
      } else {
        setAddress("Address not found");
      }
    } catch (error) {
      console.error("Geocoding error:", error);
      setAddress("Error retrieving address");
    }
  };

  useEffect(() => {
    if (open && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCenter({ lat: latitude, lng: longitude });
          geocodeAddress({ lat: latitude, lng: longitude });
          setSelectedLocation({ lat: latitude, lng: longitude });
          setLoadingLocation(false);
        },
        (error) => {
          console.error("Error fetching location:", error);
          setLoadingLocation(false);
        },
      );
    }
  }, [open]);

  useEffect(() => {
    if (isLoaded) {
      geocodeAddress(center);
      setSelectedLocation(center);
    }
  }, [isLoaded, center]);

  const handleMapClick = async (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    const location = { lat, lng };
    setSelectedLocation(location);

    geocodeAddress(location);
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose(false);
      }}
      closeAfterTransition
    >
      <Fade in={open}>
        <Box
          sx={{
            backgroundColor: "grey",
            padding: 0,
            borderRadius: 3,
            maxWidth: "90vw",
            height: "90vh",
            overflow: "hidden",
            margin: "auto",
            marginTop: "5%",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            boxShadow: 5,
            border: "1px solid #ddd",
            position: "relative",
          }}
        >
          <Box
            sx={{
              p: 2,
              width: "90vw",
              paddingLeft: "60px",
              borderBottom: "1px solid #ddd",
              bgcolor: "#f5f5f5",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
              position: "sticky",
              top: 0,
              zIndex: 10,
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 600, color: "#333" }}>
              Map
            </Typography>
          </Box>

          <Box
            sx={{
              backgroundColor: "white", // white sheet inside modal
              display: "flex",
              justifyContent: "center", // Center horizontally
              alignItems: "center", // Center vertically

              width: "calc(100%)", // Limit width to 90% of the viewport width
              height: "100%",
              aspectRatio: "1 / 1.414", // Maintain A4 aspect ratio (210mm x 297mm)
              fontSize: "16px", // Default font size
              lineHeight: 1.5, // Default line height
              overflowY: "scroll", // Allow scrolling if content exceeds

              "@media (max-width: 600px)": {
                fontSize: "14px", // Smaller font on small screens
              },
              "@media (max-width: 400px)": {
                fontSize: "12px", // Further smaller font on very small screens
              },
            }}
          >
            {isLoaded && center ? (
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                zoom={10}
                center={center}
                onClick={handleMapClick}
              >
                {selectedLocation && <Marker position={selectedLocation} />}
              </GoogleMap>
            ) : (
              <Typography variant="body1">
                {loadingLocation
                  ? "Loading your location..."
                  : "Map failed to load"}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              position: "absolute", // fix position at the bottom
              bottom: 0,
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "space-between",
              padding: 2,
              borderTop: "1px solid #ddd",
              bgcolor: "#f5f5f5",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                onClose(false);
              }}
            >
              <ChevronLeft />
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleConfirm(address, selectedLocation)}
              sx={{ height: "fit-content" }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default MapModal;
